import { IBaseApiResponse } from "./IApiResponse";
import { IMetaInfo } from "./IMetaInfo";

export interface IPageDTOResponse extends IBaseApiResponse {
    data: IPageDTO[]
}

export interface IPageDTO {
    metainfo: IMetaInfo
    lblNotes: string,
    xtaxAirports: ITaxonomyDTO
    enuPageCategory: PAGE_CAT,
    lblUrlPath: IUrlPath,
    xtaxNavigationMenu: ITaxonomyDTO,
    lstModule: IModuleDTO[],
    lblSeoTitle: IUrlPath,
    lblSeoDescription: IUrlPath,
    flgReferencePage: boolean,
    enuCurrentLanguage: LANGUAGE,
    enuReferenceLanguage: LANGUAGE,
    xconReferencePage: IModuleItem,
    flgHideNavigationéath: boolean
}

export interface ITaxonomyDTO {
    linkedcontenttype: string,
    ti: ITI[]
}

export interface ITI {
    id: number,
    label: string,
    path: string,
    description: string,
    targeturl: string
}

export enum PAGE_CAT {
    Homepage = 'Homepage',
    Voli = 'Voli',
    Servizi = 'Servizi',
    Destinazione = "Destinazione"
}

export interface IUrlPath {
    [key: string]: string
}

export interface IModuleDTO {
    xconModules: IModuleItem,
    id: number
}

export interface IModuleDataDTO {
    linkedcontenttype: string,
    id: number,
    moduleData: any
}

export interface IModuleItem {
    descr: string,
    id: number,
    label: string,
    linkedcontenttype: string,
    ref: number,
    status: string,
    targeturl: string
}

export enum LANGUAGE {
    Italiano = 'Italiano',
    Inglese = 'English'
}